export const dashboard = {
  // Welcome Section
  welcomeBack: 'Welcome back!',
  dayProgress: 'Day {{current}} of {{total}} • You\'re making great progress!',
  streak: 'Streak',
  days: 'Days',

  // Date Navigation
  today: 'Today',

  // Day Names (short)
  dayNames: {
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },

  emptystate: {
    title: 'No Active Plan',
    subtitle: "You don't have an active nutrition plan yet.",
    cta: "Create My Plan"
  },

  generating: {
    title: 'Generating Your Plan...',
    subtitle: 'This will take about 2-3 minutes'
  },

  // noMealsForDay: 'No meals for this day',

  // Daily Summary Stats
  calories: 'Calories',
  protein: 'Protein',
  carbs: 'Carbs',
  fat: 'Fat',
  grams: "grams",

  // Meals Progress
  yourMeals: 'Your Meals',
  noMealsForDay: "No meals found for this day",
  mealsCompleted: '{{completed}} of {{total}} completed • {{percentage}}% done',
  breakfast: 'Breakfast',
  lunch: 'Lunch',
  dinner: 'Dinner',
  snack: 'Snack',
  snack1: 'Snack 1',
  snack2: 'Snack 2',
  completed: 'Completed',
  markComplete: 'Mark',
  viewRecipe: 'View Recipe',
  generateRecipe: 'Generate Recipe',

  // Meal Times
  mealTimes: {
    breakfast: '07:00 - 09:00',
    lunch: '12:00 - 14:00',
    dinner: '18:00 - 20:00',
  },

  // Hydration Tracker
  waterIntake: 'Water Intake',
  stayHydrated: 'Stay hydrated!',
  drankToday: 'Drank today',
  cups: 'Cups',
  goal: 'Goal',

  // Daily Tip
  tipOfTheDay: 'Tip of the Day',
  dailyTipText: 'Drink a glass of water before each meal. It helps your metabolism and supports your feeling of fullness!',

  // Quick Actions
  fullPlan: 'Full Plan',
  viewAll30Days: 'View all 30 days',
  progress: 'Progress',
  trackYourProgress: 'Track your development',

  upgradeToVip: 'Upgrade to VIP to unlock all features.',
  vipFeaturesDescription: 'Get full access to personalized meal plans, advanced insights, and priority support with the VIP plan.',

  // Floating Action Button Menu
  fabMenu: {
    dashboardOverview: 'Dashboard Overview',
    adjustPlan: 'Adjust plan',
    viewAllRecipes: 'View all recipes',
    weightMeasurements: 'Quick Weight Log',
    viewAchievements: 'Review achievements',
    viewShoppingList: 'View shopping list',
    motivation: 'Motivation',
    todayAgenda: 'What\'s on the agenda today?',
  },

  // Streak Modal
  streakModal: {
    title: 'Day Streak!',
    subtitle: 'You\'re on fire! 🔥',
    currentStreak: 'Current Streak',
    longestStreak: 'Longest Streak',
    daysInRow: 'Days in a row',
    daysRecord: 'Days Record',
    last7Days: 'Last 7 Days',
    milestones: 'Milestones',
    milestone1Week: '1 Week',
    milestone2Weeks: '2 Weeks',
    milestone1Month: '1 Month',
    milestone2Months: '2 Months',
    milestone100Days: '100 Days',
    daysStreak: 'Days Streak',
    achieved: 'Achieved!',
    keepGoing: 'Keep going!',
    daysToNext: 'You are only {{days}} days away from your next milestone. Keep it up and reach the {{milestone}} mark!',
  },

  // Water Intake Modal
  waterModal: {
    title: 'Water Intake',
    subtitle: 'Track your daily hydration',
    reset: 'Reset',
    cups: 'Cups',
    of: 'of',
    quickActions: 'Quick Actions',
    cupsToday: 'Cups today',
    settings: 'Settings',
    cupSize: 'Cup Size',
    cupSizeSmall: '150ml (Small)',
    cupSizeStandard: '200ml (Standard)',
    cupSizeMedium: '250ml (Medium)',
    cupSizeLarge: '300ml (Large)',
    cupSizeXLarge: '350ml (Extra Large)',
    cupSizeBottle: '500ml (Bottle)',
    dailyTarget: 'Daily Target (Cups)',
    equivalentLiters: 'Equals {{liters}}L per day',
    healthTips: 'Hydration Tips',
    tip1: '💧 Drink a glass of water right after waking up',
    tip2: '🍽️ Drink a glass of water before each meal',
    tip3: '⏰ Set hourly reminders',
    tip4: '🏃 Drink extra water after exercise',
    tip5: '🌡️ Drink more on hot days',
    cancel: 'Cancel',
    save: 'Save',
  },

  // ChatBot
  chatBot: {
    // Existing keys
    title: 'NutriBot Coach',
    subtitle: 'Full access to Dashboard, Plan, Recipes & more',
    placeholder: 'Ask me about nutrition, recipes, or your goals...',
    footerNote: '💡 NutriBot has full access to Dashboard, Nutrition Plan, Recipes, Shopping List, Progress & Settings',
    quickAction1: 'Create weekly list',
    quickAction2: 'Swap recipe',
    quickAction3: 'Increase calories',
    quickAction4: 'Edit profile',
    openNow: 'Open now',
    showInDashboard: 'Show in Dashboard',
    availableProducts: '🛒 Available products for this week:',
    seeProductCards: '(See product cards below)',
    toShoppingList: 'To complete shopping list',
    inStock: 'In Stock',
    buy: 'Buy',
    yesNo: '🤔 **Please answer with "Yes" or "No"**\n\n• **Yes** = Nutrition plan, recipes and shopping list will be automatically adjusted\n• **No** = Only profile will be updated, everything else remains unchanged',
    noMatch: 'No match',
    online: 'Online',
    greeting: 'Hi there! 👋',
    introduction: 'I\'m NutriBot, your AI nutrition coach. Ready to create your personalized meal plan?',

    loadingMore: 'Loading older messages...',

    // NEW: Chat interface translations
    searchPlaceholder: 'Search messages...',
    of: 'of',
    typing: 'Typing...',
    today: 'Today',
    yesterday: 'Yesterday',
    upgradePrompt: 'Upgrade to VIP for unlimited coaching.',

    // NEW: Meal Plan Preview translations
    planPreview: {
      title: '{{days}}-Day Meal Plan Preview',
      expandAll: 'Expand All',
      collapseAll: 'Collapse All',
      kcalPerDay: 'kcal/day',
      days: 'days',
      mealsPerDay: 'meals/day',
      day: 'Day {{number}}',
      kcal: 'kcal',
      meals: 'meals',
      footerPrompt1: 'Say',
      looksPerfect: 'looks perfect',
      footerPrompt2: 'to create this plan, or',
      changeDay: 'change day X',
      footerPrompt3: 'to make adjustments!',
    },

    error: "Error",
    unknownError: "Sorry, an unknown error occurred",
    upgradeVip: "Upgrade to VIP for unlimited coaching."
  },

  // Common
  close: 'Close',
  open: 'Open',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',

  layout: {
    logo: 'NutriBot',
    chatButton: 'Ask NutriBot',
    menu: {
      dashboard: 'Dashboard',
      nutritionPlan: 'Nutrition Plan',
      recipes: 'Recipes',
      shoppingList: 'Shopping List',
      progress: 'Progress',
      profile: 'Profile',
      vipOnly: 'This feature is only available for VIP members!'
    },
    userMenu: {
      language: 'Language',
      learnMore: 'Learn more',
      help: 'Help',
      upgradePlan: 'Upgrade plan',
      logout: 'Logout'
    }
  },

  completion: {
    title: 'Day {{day}} Complete',
    subtitle: 'Amazing work! 🎉',
    meals: 'Meals',
    calories: 'kcal',
    streak: 'You\'re on a {{count}}-day streak!',
    continue: 'Keep Going!',
  },

  // Day Status Banner
  dayStatus: {
    completedToday: 'Day Complete! Amazing work!',
    completedPast: 'Day {{day}} Completed',
    stats: '{{calories}} kcal • {{protein}}g protein • {{meals}}/{{total}} meals',

    missed: {
      title: 'Day {{day}}',
      message1: '💪 Every day is a fresh start!',
      message2: '🌟 Progress, not perfection!',
      message3: '🎯 Focus on today, you\'ve got this!',
      message4: '💚 One step at a time, keep moving forward!',
    },
  },

  logoutModal: {
    title: 'Confirm Logout',
    subtitle: "You're about to sign out",
    message: "Are you sure you want to log out? You'll need to sign in again to access your dashboard.",
    cancelButton: 'Cancel',
    confirmButton: 'Logout',
    loggingOut: 'Logging out...',
  },

  goalForecast: {
    // Main titles
    title: 'Goal Forecast',
    maintainTitle: 'Weight Maintenance',

    // No data states
    noData: 'Complete a few days of your plan and log your weight to see your goal forecast.',

    // Weight labels
    current: 'Current',
    currentWeight: 'Current Weight',
    target: 'Target',
    targetWeight: 'Target Weight',
    complete: 'Complete',

    // Goal-specific labels
    lossRate: 'Loss Rate',
    gainRate: 'Gain Rate',
    toGo: 'to go',
    toGain: 'to gain',

    // Projected date section
    projectedDate: 'Projected Goal Date',
    days: 'days',
    weeks: 'weeks',

    // Stats labels
    currentPace: 'Current Pace',
    confidence: 'Confidence',
    calculating: 'Calculating...',

    // Status badges
    ahead: 'Ahead of Schedule',
    onTrack: 'On Track',
    behind: 'Slightly Behind',
    stalled: 'Progress Stalled',
    insufficientData: 'Gathering Data',

    // Maintain goal statuses
    maintainingWell: 'Maintaining Well',
    adjustNeeded: 'Slight Adjustment Needed',

    // Contextual messages
    stalledMessage: 'Your progress has stalled. Consider adjusting your calorie intake or activity level.',
    behindMessage: 'You\'re slightly behind schedule. Stay consistent and you\'ll get back on track!',

    // Info modal
    howItWorks: 'How Goal Forecast Works',
    infoTheoryTitle: 'Your Nutrition Plan (Theory)',
    infoTheoryDesc: 'Expected weight change from your current calorie',
    infoTheoryDescDeficit: 'deficit',
    infoTheoryDescSurplus: 'surplus',

    infoRealityTitle: 'Your Actual Progress (Reality)',
    infoRealityDesc: 'Your real weight trend over the past weeks.',

    infoBlendingTitle: 'Intelligent Blending',
    infoBlendingEarly: 'Early: More theory',
    infoBlendingLater: 'Later: More reality',

    infoStabilityTitle: 'Stability Protection',
    infoStabilityDesc: 'Your date won\'t jump around from day-to-day fluctuations. Only consistent trends shift the forecast.',

    infoImportantTitle: 'Important',
    infoImportantDesc: 'This is a forecast, not a guarantee. Continue your plan to stay on track!',
  }
};
